import { render, staticRenderFns } from "./Rates.vue?vue&type=template&id=e73678c4&lang=pug&"
import script from "./Rates.vue?vue&type=script&lang=ts&"
export * from "./Rates.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports